import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { firstItem } from '../../../utils/listUtils'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Lot } from '../state/types'
import { NO_LOT } from '../utils/lotUtils'

export const useLotLoaders = () => {
    const systemHooks = useSystemStateHooks()
    
    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadAllLots = () => {
            const { loadAll } = loaders(companyId)
            return loadAll(TableName.LOTS) as Promise<Lot[]>
        }

        const loadLot = (id: string) => {
            const { load } = loaders(companyId)
            return load(TableName.LOTS, id) as Promise<O<Lot>>
        }

        const loadLots = (ids: string[]) => {
            const { loadByIds } = loaders(companyId)
            return loadByIds(TableName.LOTS, ids) as Promise<Lot[]>
        }

        const loadProductLots = (productId: string, dbRequest = false) => {
            const { loadFiltered } = loaders(companyId)
            return loadFiltered(TableName.LOTS, dbRequest, { productId }) as Promise<Lot[]>
        }

        const loadProductsLots = (
            productIds: string[],
            dbRequest = false
        ) => {
            const { loadFilteredByList } = loaders(companyId)
            return loadFilteredByList(TableName.LOTS, dbRequest, 'productId', productIds) as Promise<Lot[]>
        }

        const loadProductBaseLot = async (productId: string, dbRequest = false) => {
            const { loadFiltered } = loaders(companyId)
            const params = { productId, code: NO_LOT }
            const lots = await loadFiltered(TableName.LOTS, dbRequest, params) as Lot[]
            return firstItem(lots)
        }

        return {
            loadAllLots,
            loadLot,
            loadLots,
            loadProductLots,
            loadProductsLots,
            loadProductBaseLot
        }
    }
}
